<template>
    <div>
        <div class="spacer-112"></div>

        <div class="d-flex justify-content-center align-items-center">
            <div class="bg-white d-flex flex-column" style="max-width: 421px; padding: 48px">
                <div class="d-flex justify-content-center mb-3">
                    <i class="las la-check-circle" style="font-size: 80px; color: #C64885"></i>
                </div>

                <div class="text-center">
                    <p class="pb-3 fs-2 fw-700">
                        {{$trans('storefront::flexible_packaging.query_send_success')}}
                    </p>
                    <p class="fs-3">
                        {{$trans('storefront::flexible_packaging.query_send_description')}}
                    </p>
                </div>

                <div class="spacer-48"></div>

                <a href="/" class="btn btn-primary text-uppercase">
                    <span class="d-none d-md-block">{{$trans('storefront::flexible_packaging.return_to_home_page')}}</span>
                    <span class="d-md-none">{{$trans('storefront::flexible_packaging.return_to_home_page_short')}}</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import {useFlexiblePackagingStore} from "../../js/store";

export default {
    setup() {
        const store = useFlexiblePackagingStore();
        return {
            store: store,
        }
    },
}
</script>
